import React from 'react'
import PropTypes from 'prop-types'
import Breadcrumb from 'component/Breadcrumb'

const CommercialManagementHeader = (props) => {
  const { translate } = props

  const renderBreadcrumb = () => {
    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('commercial-management.title') },
    ]

    return <Breadcrumb steps={steps} />
  }

  return renderBreadcrumb()
}

CommercialManagementHeader.propTypes = {
  translate: PropTypes.func.isRequired,
}

export default CommercialManagementHeader
